<template>
	<div>
		<h1>
			<translate>Claim Analytics</translate>
		</h1>

		<v-tabs
			fixed-tabs
			slider-color="#68bd45"
		>
			<v-tab>
				<translate>Data Changes</translate>
			</v-tab>
			<v-window-item>
				<fieldset>
					<vertical-tulip-timeline
						:claim-id="claimId"
					/>
				</fieldset>
			</v-window-item>
			<v-tab>
				<translate>Data Overview</translate>
			</v-tab>
			<v-window-item>
				<fieldset>
					<claim-data-overview
						:background-data="backgroundData"
					/>
				</fieldset>
			</v-window-item>
			<v-tab>
				<translate>Suspicious Data</translate>
			</v-tab>
			<v-window-item>
				<fieldset>
					<claim-suspicious-data
						:background-data="backgroundData"
					/>
				</fieldset>
			</v-window-item>
		</v-tabs>
	</div>
</template>

<script>
import VerticalTulipTimeline from '../../../organisms/VerticalTulipTimeline.vue';
import ClaimDataOverview from '../../../organisms/ClaimDataOverview.vue';
import ClaimSuspiciousData from '../../../organisms/ClaimSuspiciousData.vue';
import axios from 'axios';

export default {
	name: 'ClaimAnalytics',
	components: {
		ClaimSuspiciousData, ClaimDataOverview, VerticalTulipTimeline,
	},
	props: {
		claimId: {
			type: Number,
			required: true,
		},
	},
	data () {
		return {
			backgroundData: [],
		};
	},
	mounted () {
		// Retrieve all of the claim form data changes related to the claim in question
		axios
			.get(`/bo/claims/allClaimVisitDataChanges?claim_id=${this.claimId}`)
			.then((response) => {
				for (const field in response.data) {
					if (Object.prototype.hasOwnProperty.call(response.data, field)) {
						const obj = {
							name: field,
							data: response.data[field].data,
							risk: (response.data[field].metric_value > 0 ? 'Increased' : 'Safe'),
							description: response.data[field].description,
							metricValue: response.data[field].metric_value,
							precision: response.data[field].precision,
						};

						this.backgroundData.push(obj);
					}
				}
			})
			.catch((error) => {
				window.captureException(error);
			});
	},
};
</script>
